module.exports = " <canvas class=chartjs :width=width :height=height></canvas> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-chartjs/src/Chartjs.vue
// module id = 915
// module chunks = 2